import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./store/store";
import axios from 'axios';
import { API_URL, API_URL_UM } from './config';

// Configurar interceptor global de axios para agregar token a todas las peticiones
axios.interceptors.request.use(
    (config) => {
        // Solo agregar token si la petición es a nuestra API (no a API_URL_UM)
        if (config.url && config.url.startsWith(API_URL)) {
            // Obtener el token del localStorage
            const token = localStorage.getItem('token');
            
            if (token) {
                try {
                    // El token está almacenado como JSON string, necesitamos parsearlo
                    const parsedToken = JSON.parse(token);
                    
                    // Agregar el token al header X-Access-Token
                    config.headers['X-Access-Token'] = parsedToken;
                    
                    // También agregar como Authorization Bearer (estándar)
                    config.headers['Authorization'] = `Bearer ${parsedToken}`;
                } catch (error) {
                    console.error('Error al parsear token:', error);
                }
            }
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar respuestas de error (401, 403)
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            if (error.config && error.config.url) {
                const isHarasApi = error.config.url.startsWith(API_URL);
                const isUserManagerApi = API_URL_UM && error.config.url.startsWith(API_URL_UM);
                if (isHarasApi || isUserManagerApi) {
                    if (error.response.status === 401 || error.response.status === 403) {
                        if (window.location.pathname === '/telegram-bind') {
                            return Promise.reject(error);
                        }
                        localStorage.removeItem('token');
                        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && window.location.pathname !== '/reset-password') {
                            window.location.href = '/';
                        }
                    }
                }
            }
        }
        return Promise.reject(error);
    }
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
